// extracted by mini-css-extract-plugin
export default {"pageWithHeader":"Chip_pageWithHeader__xcTzs","ant-wave":"Chip_ant-wave__oVNgT","chip":"Chip_chip__ox+P-"};